export default __webpack_public_path__ + "static/media/151-electric-2.2dc79ad5.png";